module.exports = __webpack_public_path__ + "static/img/FR.8dcf04bb.jpg";